import { Fancybox } from '@fancyapps/ui';
import { Swiper } from 'swiper';
import { A11y, Navigation, Pagination } from 'swiper/modules';

if (!customElements.get('product-model')) {
  customElements.define(
    'product-model',
    class ProductModel extends HTMLElement {
      constructor() {
        super();
      }

      loadContent() {
        Shopify.loadFeatures([
          {
            name: 'model-viewer-ui',
            version: '1.0',
            onLoad: this.setupModelViewerUI.bind(this),
          },
        ]);
      }

      setupModelViewerUI(errors) {
        if (errors) return;

        this.modelViewerUI = new Shopify.ModelViewerUI(this.querySelector('model-viewer'));
      }
    }
  );
}

window.ProductModel = {
  loadShopifyXR() {
    Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXR.bind(this),
      },
    ]);
  },

  setupShopifyXR(errors) {
    if (errors) return;

    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', () => this.setupShopifyXR());
      return;
    }

    document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
      window.ShopifyXR.addModels(parseJson(modelJSON.textContent));
      modelJSON.remove();
    });
    window.ShopifyXR.setupXRElements();
  },
};

window.addEventListener('DOMContentLoaded', () => {
  if (window.ProductModel) window.ProductModel.loadShopifyXR();
});

if (!customElements.get('product-media')) {
  class ProductMedia extends HTMLElement {
    constructor() {
      super();
      this.swiper();
      this.fancybox();
    }

    swiper() {
      // Check if Swiper exists
      if (typeof Swiper == 'undefined') {
        return false;
      }

      // Get swiper element
      this.swiperElement = this.querySelector('[data-product-media-swiper]');

      const modelIndexes = this.modelIndexes;
      const modelIcon = this.modelIcon;

      // Swiper options
      this.swiperOptions = {
        modules: [A11y, Navigation, Pagination],
        threshold: 10,
        direction: 'horizontal',
        createElements: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          renderBullet: function (index, className) {
            const content = modelIndexes.includes(index) ? modelIcon?.innerHTML ?? '' : '';
            if (content) className += ' swiper-pagination-3d';
            return `<span class="${className}">${content}</span>`;
          },
        },
      };

      // Init swiper
      this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);

      // Rebuild Swiper in design mode
      if (Shopify.designMode && this.swiperInstance) {
        window.addEventListener('shopify:section:load', () => {
          this.swiperInstance.update();
        });
      }
    }

    get modelIndexes() {
      return this.dataset.modelIndexes?.split(',').map((index) => parseInt(index) - 1);
    }

    get modelIcon() {
      return this.querySelector('.model-icon');
    }

    /*
     * Create fancybox
     */
    fancybox() {
      // Check if Fancybox exists
      if (typeof Fancybox == 'undefined') {
        return false;
      }

      const container = this.querySelector('.fancybox__container');
      if (container) this.initFancyboxPaginationBullets(container);

      Fancybox.bind('[data-fancybox]', {
        animated: false,
        showClass: false,
        mainClass: 'image-zoom',
        click: false,
        Carousel: {
          Dots: true,
          Navigation: true,
          Panzoom: {
            touch: (panzoom, event) => {
              return event?.target.nodeName !== 'MODEL-VIEWER';
            },
            click: (panzoom, event) => {
              return event?.target.nodeName !== 'MODEL-VIEWER';
            },
          },
        },
        on: {
          '*': (fancybox) => {
            if (!fancybox.container) return;

            this.initFancyboxPaginationBullets(fancybox.container);
            this.initXRButton(fancybox);
          },
        },
      });
    }

    initXRButton(fancybox) {
      // Current slide
      const slide = fancybox.getSlide();

      if (!slide) return;

      this.initFancyboxPaginationBullets(fancybox.container);
      // The corresponding trigger element
      // (i.e. the link that is clicked to launch Fancybox)
      const triggerEl = slide.triggerEl;
      const parent = triggerEl.closest('[data-media-id]');

      if (!parent || !slide.el) return;

      const xrButtonInSlide = slide.el.querySelector('.fancybox-xr-button');
      if (xrButtonInSlide) return;

      const mediaId = parent.dataset?.mediaId;
      const xrButton = parent.querySelector('[data-shopify-xr]');
      const xrButtonClone = xrButton?.cloneNode(true);

      xrButtonClone.classList.add('fancybox-xr-button');

      xrButtonClone?.addEventListener('click', () => {
        document.querySelector(`[data-shopify-model3d-id="${mediaId}"]`).click();
      });

      // append the xr button to the fancybox slide
      slide.el?.appendChild(xrButtonClone);
    }

    initFancyboxPaginationBullets(container) {
      if (!container) return;

      const dots = container.querySelector('.f-carousel__dots');

      if (!dots) return;

      const modelIndexes = this.modelIndexes;
      const modelIcon = this.modelIcon;

      Array.from(dots.children).forEach((dot, index) => {
        const span = dot.querySelector('.f-carousel__dot');
        const isModelDot = modelIndexes.includes(index);

        if (!isModelDot || !span || span.classList.contains('f-carousel__dot-3d')) return;

        span.innerHTML = modelIcon.innerHTML;
        span.classList.add('f-carousel__dot-3d');
      });
    }
  }

  window.ProductMedia = ProductMedia;

  customElements.define('product-media', ProductMedia);
}
